import React, { useState } from 'react';
//import BasicCard from 'src/common/components/card/basicCard/BasicCard';
import Card from 'src/common/refactoredComponents/card/Card';
import BundleTag from 'src/common/components/orderDetails/bundleTag/BundleTag';
// import SubItemDatatable from '../detailsDataTable/subItemsDatatable/SubItemsDatatable';
import SubItemDatatable from '../../../../../../../common/components/orderDetails/subItemsDatatable/SubItemsDatatable';
import CfnLabel from 'src/common/components/orderDetails/bundleCards/CfnLabel';
import SerialNoLabel from 'src/common/components/orderDetails/bundleCards/SerialNoLabel';
import ItemDescriptionLabel from 'src/common/components/orderDetails/bundleCards/ItemDescriptionLabel';
import QuantityContainer from 'src/common/components/orderDetails/bundleCards/QuantityContiner';
import PricingContainer from 'src/common/components/orderDetails/bundleCards/PricingContainer';
import BundleLayout from 'src/common/components/orderDetails/bundleCards/BundleLayout';

import {
    UsagePricingContainer,
    UsagePricingDataContainer,
    UsagePriceFont,
    UsagePricingFullWidth,
    Discount,
} from './BundleCards.styled';
import { useTranslation } from 'react-i18next';

const BundleCards = ({
    setDetailsData,
    setItemHandler,
    keyIndex,
    isBundle,
    cfn,
    quantity,
    uom,
    isUsed,
    serialNo,
    description,
    brand,
    isEquity,
    // poNumber,
    unitPrice,
    subUnitPrice,
    extPrice,
    subExtPrice,
    discount,
    subItemsData,
    subItemsColumns,
    descriptionMobileFontSize,
    isAccountOwned,
    isNotBilled,
    status,
    isBillingSummary,
}) => {
    const [showBundleSubItems, setShowBundleSubItems] = useState(false);
    const { t } = useTranslation();

    const showBundleSubItemsHandler = () => {
        setShowBundleSubItems(!showBundleSubItems);
    };

    return (
        <Card
            key={keyIndex}
            border={
                isAccountOwned || isNotBilled ? 'none' : '1px solid #74DED6'
            }
            padding={'10px'}
            width={isAccountOwned || isNotBilled ? '98%' : undefined}
            margin={
                isAccountOwned || isNotBilled
                    ? '10px auto 0 auto'
                    : '10px 0 0 0'
            }
        >
            <UsagePricingContainer>
                <BundleLayout
                    isExpand={showBundleSubItems ? true : false}
                    bundleClickHandler={showBundleSubItemsHandler}
                    isShowBundleSubItem={showBundleSubItems}
                    isBundle={isBundle}
                >
                    <UsagePricingFullWidth>
                        <UsagePricingDataContainer
                            alignItems={'center'}
                            justifyContent={'flex-start'}
                            width={isBundle ? '70%' : '50%'}
                        >
                            <CfnLabel
                                cfnFontColor={isBundle && '#140F4B'}
                                setItemHandler={setItemHandler}
                                setDetailsData={setDetailsData}
                                cfn={cfn}
                                isShowSetItemDetails={!isBundle ? true : false}
                                cursor={'pointer'}
                            />
                            {isBundle ? (
                                <BundleTag
                                    bundleFontOpacity={'0.92'}
                                    value={'Bundle'}
                                />
                            ) : null}
                        </UsagePricingDataContainer>
                        <UsagePricingDataContainer
                            margin={'0'}
                            width={isBundle ? '30%' : '50%'}
                        >
                            <QuantityContainer
                                quantity={quantity}
                                isUsed={isUsed}
                                uom={uom}
                                isShowUom={!isBundle ? true : false}
                                alignItems={'center'}
                                showLabel={true}
                            />
                        </UsagePricingDataContainer>
                    </UsagePricingFullWidth>
                    <UsagePricingFullWidth>
                        {serialNo ? (
                            <SerialNoLabel
                                serialNo={serialNo}
                                showLabel
                                marginContainer={'0 0 5px 0'}
                            />
                        ) : null}
                    </UsagePricingFullWidth>
                    <UsagePricingFullWidth>
                        <ItemDescriptionLabel
                            lineHeight={'19px'}
                            letterSpacing={'-0.1px'}
                            description={description}
                            brand={brand}
                            isEquity={isEquity}
                            mobileFontSize={descriptionMobileFontSize}
                        />
                    </UsagePricingFullWidth>
                    {!isAccountOwned && !isNotBilled ? (
                        <UsagePricingFullWidth>
                            <UsagePricingDataContainer
                                flexDirection={'column'}
                                width={'40%'}
                                margin={'0 0 5px 0'}
                                alignItems={'flex-start'}
                            >
                                {/* {poNumber ? ( */}
                                {status ? (
                                    <>
                                        <UsagePriceFont
                                            color="#202124"
                                            fontFamily="AvenirNextWorld Demi"
                                            margin={'0 0 5px 0'}
                                        >
                                            {/* {`PO:`} */}
                                            {t(
                                                'more.common.setsAndItems.status'
                                            )}
                                        </UsagePriceFont>
                                        <UsagePriceFont
                                            color="#202124"
                                            fontSize="14px"
                                        >
                                            {/* {poNumber ? poNumber : null} */}
                                            {status ? status : null}
                                        </UsagePriceFont>
                                    </>
                                ) : null}
                                {discount ? (
                                    <Discount>{discount}% Discount</Discount>
                                ) : null}
                            </UsagePricingDataContainer>

                            <UsagePricingDataContainer width={'30%'}>
                                <PricingContainer
                                    pricingLabel={t(
                                        'orders.orderDetails.billingSummary.index.unitPrice'
                                    )}
                                    price={unitPrice}
                                    subPrice={subUnitPrice}
                                />
                            </UsagePricingDataContainer>
                            <UsagePricingDataContainer width={'30%'}>
                                <PricingContainer
                                    pricingLabel={t(
                                        'orders.orderDetails.billingSummary.index.extPrice'
                                    )}
                                    price={extPrice}
                                    subPrice={subExtPrice}
                                    isBillingSummary={isBillingSummary}
                                />
                            </UsagePricingDataContainer>
                        </UsagePricingFullWidth>
                    ) : null}
                    {isAccountOwned || isNotBilled ? (
                        <UsagePricingFullWidth>
                            <UsagePricingDataContainer
                                flexDirection={'column'}
                                width={'100%'}
                                margin={'0 0 5px 0'}
                                alignItems={'flex-end'}
                                justifyContent={'flex-end'}
                            >
                                <UsagePriceFont
                                    fontFamily={'AvenirNextWorld Demi'}
                                    color="#989898"
                                    fontSize="12px"
                                    lineHeight={'21px'}
                                >
                                    {t('reportUsage.summary.accountOwned')}
                                </UsagePriceFont>
                            </UsagePricingDataContainer>
                        </UsagePricingFullWidth>
                    ) : null}
                </BundleLayout>

                {showBundleSubItems ? (
                    <UsagePricingFullWidth>
                        <SubItemDatatable
                            colDatas={subItemsColumns}
                            rowDatas={subItemsData}
                            setItemHandler={setItemHandler}
                            isEquity={isEquity}
                        />
                    </UsagePricingFullWidth>
                ) : null}
            </UsagePricingContainer>
        </Card>
    );
};

export default BundleCards;
